module.exports = __webpack_public_path__ + "static/media/next-step-button-small.5ac62237.svg";